import { render, staticRenderFns } from "./Privacys.vue?vue&type=template&id=6590dc1c&"
var script = {}
import style0 from "./Privacys.vue?vue&type=style&index=0&id=6590dc1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports